import type { DrawerField } from "@/components/RecordDrawer";

/**
 * The fields each directory drawer shows (v2.1 T6.1), in the order a person fills them in. The
 * select options are the Postgres enum labels, so a value the database would refuse cannot be picked.
 */
export const VENDOR_TYPES = [
  "surveyor", "soil_scientist", "civil_engineer", "land_planner", "architect", "land_use_attorney",
  "closing_attorney", "title_company", "realtor_broker", "geotech", "environmental",
  "excavation_contractor", "utility_provider", "county_staff", "appraiser", "lender",
  "data_provider", "other",
] as const;

export const VENDOR_FIELDS: DrawerField[] = [
  { key: "name", label: "Name", required: true },
  { key: "type", label: "Type", type: "select", options: VENDOR_TYPES },
  { key: "company", label: "Company" },
  { key: "phone_e164", label: "Phone", hint: "+15551234567" },
  { key: "email", label: "Email" },
  { key: "website", label: "Website" },
  { key: "states", label: "States", type: "list", hint: "Comma separated: TN, KY" },
  { key: "counties", label: "Counties", type: "list" },
  { key: "typical_turnaround_days", label: "Typical turnaround (days)", type: "number" },
  { key: "rating", label: "Rating (1-5)", type: "number" },
  { key: "active", label: "Active", type: "bool" },
  { key: "notes", label: "Notes", type: "textarea" },
];

export const INVESTOR_FIELDS: DrawerField[] = [
  { key: "name", label: "Name", required: true },
  {
    key: "type",
    label: "Type",
    type: "select",
    options: ["private_money", "hard_money", "jv_equity", "family_office", "institutional", "friend_family"],
  },
  {
    key: "status",
    label: "Status",
    type: "select",
    options: ["prospect", "warm", "soft_commit", "committed", "funded", "passed"],
  },
  { key: "entity", label: "Entity" },
  { key: "contact_name", label: "Contact" },
  { key: "phone_e164", label: "Phone", hint: "+15551234567" },
  { key: "email", label: "Email" },
  { key: "check_min_cents", label: "Check min ($)", type: "money" },
  { key: "check_max_cents", label: "Check max ($)", type: "money" },
  { key: "preferred_states", label: "Preferred states", type: "list" },
  { key: "preferred_strategies", label: "Preferred strategies", type: "list" },
  { key: "rate_terms", label: "Rate / terms" },
  { key: "notes", label: "Notes", type: "textarea" },
];

export const BUYER_FIELDS: DrawerField[] = [
  { key: "name", label: "Name", required: true },
  { key: "type", label: "Type", type: "select", options: ["investor", "builder", "developer", "end_user", "broker"] },
  { key: "entity", label: "Entity" },
  { key: "phone_e164", label: "Phone", hint: "+15551234567" },
  { key: "email", label: "Email" },
  { key: "states", label: "States", type: "list" },
  { key: "counties", label: "Counties", type: "list" },
  { key: "min_acres", label: "Min acres", type: "number" },
  { key: "max_acres", label: "Max acres", type: "number" },
  { key: "cash", label: "Cash buyer", type: "bool" },
  { key: "score", label: "Score", type: "number" },
  { key: "notes", label: "Notes", type: "textarea" },
];

export const ENGAGEMENT_SERVICES = [
  "boundary_survey", "topo_survey", "plat_prep", "perc_test", "soil_map", "phase_1_esa",
  "wetlands_delineation", "geotech", "civil_design", "site_plan", "drainage_study",
  "rezoning_application", "variance", "title_search", "title_commitment", "closing", "listing",
  "buyer_rep", "bpo_appraisal", "utility_capacity_letter", "clearing_road", "funding",
  "legal_review", "other",
] as const;
